import { APIClient } from "./api_helper";

import * as url from "./url_helper"

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// login 
export const postFakeLogin = (data : any) => api.create(url.POST_FAKE_LOGIN, data);

// register
export const postFakeRegister = (data : any) => api.create(url.POST_FAKE_REGISTER, data);